module.exports = __webpack_public_path__ + "img/sponsor.d87bdfe7.png";